import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { SportcastRequestFormatter } from "../SportcastRequestFormatter";
export function createSportcastConnection() {
    return createRESTConn({
        name: ConnectionNames.sportcast,
        handlers: {
            requestFormatter: SportcastRequestFormatter
        }
    });
}
//# sourceMappingURL=CreateSportcastConnection.js.map